import { ModelBase, Property } from '@skylab-shared/core';

export class ExchangeRateModel extends ModelBase {
    @Property({nullable: true})
    public date: Date;

    @Property()
    public manual: boolean;

    @Property()
    public rate: number;

    @Property()
    public units: number;

    @Property(String,{ nullable: true})
    public tableNo: string | null;
}
    